import { Color } from '@teetsh/app/src/types/colors';

export function adjustTailwindColorForPrint(tailwindColor: Color): Color {
  // Split the color name into base color and brightness level
  const [baseColor, brightnessLevel] = tailwindColor.split('-');

  if (tailwindColor === 'white') {
    return 'gray-900';
  }
  // If the color doesn't have a brightness level, return it as-is
  if (!brightnessLevel) {
    return tailwindColor;
  }
  // Convert the brightness level to a number
  const level = parseInt(brightnessLevel, 10);
  if (isNaN(level)) {
    // ignore non-numeric values like `intense`
    return tailwindColor;
  }

  // Define a threshold for adjustment
  const brightnessThreshold = 400; // Adjust this threshold as needed

  // If the color is too bright, adjust it
  if (level >= brightnessThreshold) {
    return tailwindColor; // Already dark enough
  }

  return `${baseColor}-${brightnessThreshold}` as Color;
}
